import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './index.css';
import LoginPortal from './LoginPortal';
import DevBar from './DevBar';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

const backendUrl = new URL(process.env.REACT_APP_BACKEND_URL);
const isProd = backendUrl.hostname.startsWith("prod");

root.render(
  <React.StrictMode>
    {!isProd && <DevBar />}
    <LoginPortal />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
